<template>
  <div
    class="img-zoom-content"
    :style="{
      'background-image': 'url(' + resolveImg + ')',
      ...resolveWidth
    }"
  >
    <a target="_blank" :href="imageUrl">
      <icon-zoom-img class="w-100" />
    </a>
  </div>
</template>

<script>
import IconZoomImg from "@/@core/components/svg/common/IconZoomImg.vue";
import { computed } from '@vue/composition-api';
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
export default {
  components: { IconZoomImg },
  props: {
    imageUrl: {type : String, default : ""},
    width : {type : String , default : "250px"},
    height : {type : String , default : "135px"}
  },
  setup(props){
    const resolveWidth = computed(() => {
      return {
        'width' : props.width,
        'height' : props.height
      }
    })

    const resolveImg = computed(() => {
      return props.imageUrl ? props.imageUrl : DefaultImg
    })
    return {
      resolveWidth,
      resolveImg
    }
  }
};
</script>

<style scoped>
.img-zoom-content {
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  width: 250px;
  height: 135px;
  border-radius: 10px;
  border: 1px dashed #d1d1d1;
}

.img-zoom-content > a {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  cursor: pointer;
}
</style>
